// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__pi606","textFooter":"styles_textFooter__uD9ZY","forgot":"styles_forgot__Xs503","title":"styles_title__FxiVd"};